import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

/**
 * 🔹 Payload para crear/actualizar
 */
export interface PesvNovedadesDesplazamientosPayload {
  desplazamiento_id: number;
  tipo: number;
  descripcion: string;
  accion_realizada?: string | null;
  fecha: string;
}

/**
 * 🔹 Entidad
 */
export interface PesvNovedadesDesplazamientos {
  id?: number;
  desplazamiento_id: number;
  tipo: number;
  descripcion: string;
  accion_realizada?: string | null;
  fecha: string;
  estado?: number | string | null;
  fechaCreacion?: string;
  fechaModificacion?: string;
}

/**
 * 🔹 Respuesta genérica
 */
export interface PesvNovedadesDesplazamientosResponse {
  id?: number;
  message?: string;
  error?: string;
  data?: any;
  [key: string]: any;
}

@Injectable({
  providedIn: "root",
})
export class PesvNovedadesDesplazamientosService {
  private readonly apiUrl =
    `${environment.apiUrl}/api/pesv_novedades_desplazamientos`;

  constructor(private http: HttpClient) {}

  /**
   * Obtener todas las novedades
   */
  getAll(): Observable<PesvNovedadesDesplazamientos[]> {
    return this.http.get<PesvNovedadesDesplazamientos[]>(
      this.apiUrl,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Obtener novedad por ID
   */
  getById(id: number): Observable<PesvNovedadesDesplazamientos> {
    return this.http.get<PesvNovedadesDesplazamientos>(
      `${this.apiUrl}/${id}`,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Obtener novedades por desplazamiento
   */
  getByDesplazamiento(
    desplazamientoId: number
  ): Observable<PesvNovedadesDesplazamientos[]> {
    return this.http.get<PesvNovedadesDesplazamientos[]>(
      `${this.apiUrl}/desplazamiento/${desplazamientoId}`,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Crear novedad
   */
  create(
    payload: PesvNovedadesDesplazamientosPayload
  ): Observable<PesvNovedadesDesplazamientosResponse> {
    return this.http.post<PesvNovedadesDesplazamientosResponse>(
      this.apiUrl,
      payload,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Actualizar novedad
   */
  update(
    id: number,
    payload: Partial<PesvNovedadesDesplazamientosPayload>
  ): Observable<PesvNovedadesDesplazamientosResponse> {
    return this.http.put<PesvNovedadesDesplazamientosResponse>(
      `${this.apiUrl}/${id}`,
      payload,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Eliminar novedad
   */
  remove(id: number): Observable<any> {
    return this.inactivate(id);
  }

  activate(id: number): Observable<PesvNovedadesDesplazamientosResponse> {
    return this.http.put<PesvNovedadesDesplazamientosResponse>(
      `${this.apiUrl}/${id}/activar`,
      {},
      {
        withCredentials: true,
      }
    );
  }

  inactivate(id: number): Observable<PesvNovedadesDesplazamientosResponse> {
    return this.http.put<PesvNovedadesDesplazamientosResponse>(
      `${this.apiUrl}/${id}/inactivar`,
      {},
      {
        withCredentials: true,
      }
    );
  }
}